import { Action, createReducer, on } from "@ngrx/store";
import { PointsViewColumn1ViewModelActions } from "../actions";
import {
  initialState,
  Column1ViewModelState,
} from "../states/column_1_view_model.states";
export const PointsViewColumn1ViewModelReducer = createReducer(
  initialState,
  on(PointsViewColumn1ViewModelActions.setGenericDocPointsListing_State, (state, action) => ({
    ...state, genericDocPointsListingState: action.genericDocPointsListingState
  })),
);
export function reducer(
  state: Column1ViewModelState | undefined,
  action: Action
) {
  return PointsViewColumn1ViewModelReducer(state, action);
}